import { TraceableProcess, TrackingEvent } from '../../../services/analytics/model';

export class GeneralScheduleViewedEvent implements TrackingEvent {
  public readonly action: string = 'General Schedule Viewed';
  public readonly category: TraceableProcess = TraceableProcess.APPOINTMENT_SCHEDULING;
}
